import {put,takeLatest,call} from 'redux-saga/effects'
import * as userService from "../../../services/userService"

import {
    SET_SELECTED_USER,
    SET_SELECTED_USER_SUCCESS,
    SET_SELECTED_USER_ERROR
}
    from "../../actions/user";
function* setSelectedUserSaga(action) {
    try {
        let data={}

        if(action.payload.term)
            data=yield call(userService.SearchUser,action.payload)

        yield put({
            type: SET_SELECTED_USER_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: SET_SELECTED_USER_ERROR,error: error.data
        });
    }
}

export function* setSelectedUserSagaWatcher() {
    yield takeLatest(SET_SELECTED_USER,setSelectedUserSaga);
}